/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Carat_WeightInputs */

const en_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carat Weight`)
};

const es_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso en quilates`)
};

const fr_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids en carats`)
};

const de_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karatgewicht`)
};

const ja_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カラット重量`)
};

const zh_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`克拉重量`)
};

const ar_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوزن بالقيراط`)
};

const id_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berat Karat`)
};

const it_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso in Carati`)
};

const ru_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вес в каратах`)
};

const pt_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso em Quilates`)
};

const ko_field_carat_weight = /** @type {(inputs: Field_Carat_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캐럿 중량`)
};

/**
* | output |
* | --- |
* | "Carat Weight" |
*
* @param {Field_Carat_WeightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_carat_weight = /** @type {((inputs?: Field_Carat_WeightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Carat_WeightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_carat_weight(inputs)
	if (locale === "es") return es_field_carat_weight(inputs)
	if (locale === "fr") return fr_field_carat_weight(inputs)
	if (locale === "de") return de_field_carat_weight(inputs)
	if (locale === "ja") return ja_field_carat_weight(inputs)
	if (locale === "zh") return zh_field_carat_weight(inputs)
	if (locale === "ar") return ar_field_carat_weight(inputs)
	if (locale === "id") return id_field_carat_weight(inputs)
	if (locale === "it") return it_field_carat_weight(inputs)
	if (locale === "ru") return ru_field_carat_weight(inputs)
	if (locale === "pt") return pt_field_carat_weight(inputs)
	return ko_field_carat_weight(inputs)
});